// de_pms_housekeeping.ts
// Tłumaczenia dla PMS.Housekeeping.tsx

export const dePmsHousekeeping = {

  title: "Housekeeping",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomControl:   "Zimmerkontrolle",
    roomSnapshot:  "Zimmerstatus",
    tasks:         "Housekeeping-Aufgaben",
    maintenance:   "Wartung und Sperrung",
    realtimeFeed:  "Live-Feed",
    operations:    "Betrieb",
  },

  // ── Opisy sekcji ─────────────────────────────────────────────────────────
  descriptions: {
    roomReadiness: "Zimmerbereitschaft, Aufgabenverwaltung, Wartung, Sperrung und Echtzeitbetrieb.",
    fastUpdates:   "Schnelle Zimmerstatus-Updates mit sicherer Persistenz.",
    currentState:  "Aktueller Betriebszustand.",
    createTrack:   "Betriebliche Zimmeraufgaben erstellen und verfolgen.",
    escalate:      "Technische Störungen eskalieren und Bestand schützen.",
    prepared:      "Vorbereitet für künftiges Event-Streaming auf Mitarbeitergeräten.",
  },

  // ── Typy zadań ────────────────────────────────────────────────────────────
  taskTypes: {
    inspection:       "Inspektion",
    turndown:         "Turndown",
    deepClean:        "Grundreinigung",
    maintenanceFollowUp: "Wartungsnachkontrolle",
    taskType:         "Aufgabentyp",
  },

  // ── Statusy pokoi (specyficzne dla HK) ───────────────────────────────────
  roomStatus: {
    clean:     "Sauber",
    dirty:     "Schmutzig",
    cleaning:  "In Reinigung",
    inspected: "Geprüft",
    blocked:   "Gesperrt",
  },

  // ── Konserwacja i blokowanie ──────────────────────────────────────────────
  maintenance: {
    severity:    "Störungs-Schweregrad",
    blockRoom:   "Zimmer sperren",
    releaseBlock:"Sperre aufheben",
    resolved:    "Vom Service behoben, an Housekeeping übergeben.",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    priority:          "Priorität",
    housekeepingStatus:"Housekeeping-Status",
    unassigned:        "Nicht zugewiesen",
  },

  // ── Komunikaty błędów ─────────────────────────────────────────────────────
  messages: {
    blockFailed:            "Zimmersperre fehlgeschlagen.",
    blockReleaseFailed:     "Aufhebung der Sperre fehlgeschlagen.",
    maintenanceReportFailed:"Wartungsmeldung fehlgeschlagen.",
    maintenanceUpdateFailed:"Wartungsaktualisierung fehlgeschlagen.",
    roomUpdateFailed:       "Zimmeraktualisierung fehlgeschlagen.",
    taskCreationFailed:     "Aufgabenerstellung fehlgeschlagen.",
    taskUpdateFailed:       "Aufgabenaktualisierung fehlgeschlagen.",
  },

} as const;

export default dePmsHousekeeping;
